module.exports = __webpack_public_path__ + "img/D@2x.4cd7682.webp";